import { render, staticRenderFns } from "./slution.vue?vue&type=template&id=08487c73&scoped=true&lang=pug&"
import script from "./slution.vue?vue&type=script&lang=js&"
export * from "./slution.vue?vue&type=script&lang=js&"
import style0 from "./slution.vue?vue&type=style&index=0&id=08487c73&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08487c73",
  null
  
)

export default component.exports